var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorderqty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.04815L6.66659 5.23862M10.9447 3.87386L15.7066 6.59481C15.9983 6.76142 16.2407 7.0022 16.4093 7.29272C16.5779 7.58325 16.6666 7.9132 16.6666 8.2491V12.7043C16.6666 13.0402 16.5779 13.3702 16.4093 13.6607C16.2407 13.9512 15.9983 14.192 15.7066 14.3586L10.9447 17.0796C10.6569 17.2439 10.3313 17.3304 9.99992 17.3304C9.66854 17.3304 9.3429 17.2439 9.05516 17.0796L4.29325 14.3586C4.00158 14.192 3.75915 13.9512 3.59056 13.6607C3.42196 13.3702 3.33319 13.0402 3.33325 12.7043V8.2491C3.33319 7.9132 3.42196 7.58325 3.59056 7.29272C3.75915 7.0022 4.00158 6.76142 4.29325 6.59481L9.05516 3.87386C9.3429 3.7095 9.66854 3.62305 9.99992 3.62305C10.3313 3.62305 10.6569 3.7095 10.9447 3.87386Z",
    stroke: "#169560",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80933 7.61914L9.09695 10.4668C9.37444 10.6161 9.68466 10.6943 9.9998 10.6943C10.3149 10.6943 10.6252 10.6161 10.9027 10.4668L16.1903 7.61914M9.9998 10.9525V17.143",
    stroke: "#169560",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderqty);
export default __webpack_public_path__ + "static/media/reorderqty.cf6c86b902747822de5d50a3c9cb101c.svg";
export { ForwardRef as ReactComponent };